module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-13.34571601.png";